export const getFormatedPrice = (
    price: number,
    currency: string,
    locale: string,
    fractionDigits = 2,
) => {
    const fixedPrice = +price.toFixed(fractionDigits);
    const formatedPrice = fixedPrice.toLocaleString(locale, {
        style: 'currency',
        currency,
    });

    return formatedPrice;
};
